import { UpdateUserPassPutRequestModel } from "@/features/user/services/user-model";
import { UpdateUserPassApi } from "@/features/user/services/update-pass-api";

// 利用者ID変更処理
export class UpdateUserPassService {
  private updateUserPassApi = new UpdateUserPassApi();

  /**
   * 利用者パスワード変更API実行
   */
  public async putUpdateUserPass(param: UpdateUserPassPutRequestModel) {
    return await this.updateUserPassApi.putUpdateUserPass(param);
  }
}
